import React, { Component } from 'react';
import { connect } from 'react-redux';
import LoadingScreen from './components/shared/LoadingScreen';
import './App.css';

class App extends Component {

    state = {
        isMobile: window.outerWidth <= 900
    };

    componentDidMount() {
        window.onresize = () => {
            if (window.outerWidth <= 900 && !this.state.isMobile) this.setState({ isMobile: true });
            else if (window.outerWidth > 900 && this.state.isMobile) this.setState({ isMobile: false });
        }
    }

    render() {
        if (!this.props.systemSettings) return <LoadingScreen />;

        const pathName = window.location.pathname.toLowerCase();

        let content;

        if (this.props.systemSettings.serviceDown) {
            const ServiceDown = React.lazy(() => import('./components/ServiceDown'));
            content = <ServiceDown />;
        }
        else if (pathName === '/home/predictionsign' || pathName === '/predictionsign') {
            const PredictionSign = React.lazy(() => import('./components/PredictionSign'));
            content = <PredictionSign />;
        }
        else if (this.state.isMobile) {
            const MobilePredictionPortal = React.lazy(() => import('./components/MobilePredictionPortal'));
            content = <MobilePredictionPortal />;
        }
        else {
            const DesktopPredictionPortal = React.lazy(() => import('./components/DesktopPredictionPortal'));
            content = <DesktopPredictionPortal />;
        }

        // Note: The h1 and main structure is now handled within each portal component
        // to ensure proper landmark hierarchy (header outside main)
        return (
            <>
                {content}
            </>
        );
    }
}

export default connect((state) => {
    return { systemSettings: state.systemSettings };
})(App);